module.exports = __webpack_public_path__ + "img/pr.36524a91.svg";